import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { provideRouter, RouteReuseStrategy } from '@angular/router';

import { routes } from './app.routes';
import { ParamChangeRouteReuseStrategy } from './core/router/param-change-route-reuse.strategy';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from './core/interceptors/auth-interceptor';
import { AuthService } from './core/api/auth.service';
import { loadingInterceptor } from './core/interceptors/loading-interceptor';
import { provideTranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { CustomTranslateLoader, registerAppLocales } from './core/i18n';

registerAppLocales();

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    { provide: RouteReuseStrategy, useClass: ParamChangeRouteReuseStrategy },
    provideHttpClient(withInterceptors([loadingInterceptor, authInterceptor])),

    provideTranslateService({
      loader: () => new CustomTranslateLoader(inject(HttpClient)),
      lang: 'en',
      fallbackLang: 'en',
    }),

    provideAppInitializer(() => {
      const authService = inject(AuthService);
      return authService.initAuth();
    }),
  ],
};
